window.addEventListener('load', hideSkeleton);

function hideSkeleton() {
  $('.jc-skeleton-context').removeClass('d-none');
  $(".slick-slider").slick("refresh")
  $('.jc-catalog-skeleton-loading').addClass('d-none');
}
